<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" default-value="0">
                <a-select-option value="0">全部</a-select-option>
                <a-select-option value="1">未处理</a-select-option>
                <a-select-option value="2">成功</a-select-option>
                <a-select-option value="3">失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="用户名/手机"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number v-model="queryParam.callNo" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker v-model="queryParam.date" style="width: 100%" placeholder="请输入更新日期"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.useStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record">
        <img :src="record.user.face" style="width: 40px; vertical-align: middle;" /> {{record.user.name}}<br/>
        户名:{{record.name}}<br/>
        银行:{{record.bank}}<br/>
        账号:{{record.code}}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.status==1" color="red">未处理</a-tag>
        <a-tag v-if="record.status==2" color="green">成功</a-tag>
        <a-tag v-if="record.status==3" >失败</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template v-if="record.status==1" >
          <a @click="withdrawSuccess(record)">批准</a>
          <a-divider type="vertical" />
          <a @click="withdrawError(record)">拒绝</a>
        </template>
      </span>
    </s-table>
  </a-card> 
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'
  import UserPicker from '@/components/UserPicker/'

  import { cashaccountList ,cashaccountLogList,balanceEdit,blockedEdit,withdrawlist,withdrawSuccess,withdrawError } from '@/api/cashaccount'

  export default {
    name: 'WithdrawList',
    components: {
      AInput,
      ATextarea,
      STable,
      UserPicker
    },
    data () {
      return {
        visible: false,
        saveLoading:false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            sorter: true
          },
          {
            title: '账户信息',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '金额',
            dataIndex: 'amount',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '申请时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '200px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam = Object.assign(parameter, this.queryParam);
          return withdrawlist(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    mounted(){
    },
    methods: {
      withdrawSuccess(record){
        let that = this;
        this.$confirm({
          title: '确认审核成功?',
          content: '此操作不可恢复,请谨慎操作!',
          onOk() {
            withdrawSuccess({
              id:record.id
            }).then(res => {
              that.$message.success('操作成功')
              that.$refs.table.refresh()
            }).catch(err =>{
              that.$message.error(err.data.msg);
            })
          },
          onCancel() {},
        });
      },

      withdrawError(record){
        let that = this;
        this.$confirm({
          title: '确认审核失败?',
          content: '此操作不可恢复,请谨慎操作!',
          onOk() {
            withdrawError({
              id: record.id
            }).then(res => {
              that.$message.success('操作成功')
              that.$refs.table.refresh()
            }).catch(err => {
              that.$message.error(err.data.msg);
            })
          },
          onCancel() {
          },
        });
      },
        // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      resetSearchForm () {
        this.queryParam = {
          date: moment(new Date())
        }
      }
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>

<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
